module.exports = __webpack_public_path__ + "img/Layer 5.57067344.svg";